import OS from "../utils/OS";

export default class TextInput {
  private readonly inputEl: HTMLInputElement;
  private readonly label: PIXI.Text;
  private readonly placeholder: string | undefined;

  constructor(
    root: PIXI.Container,
    label: PIXI.Text,
    placeholder?: string,
    maxLength?: number,
  ) {
    this.label = label;
    this.placeholder = placeholder;

    this.inputEl = createInputEl();
    this.inputEl.maxLength = maxLength || 0;
    this.inputEl.onblur = this.onBlur.bind(this);
    this.inputEl.oninput = this.onInput.bind(this);

    root.interactive = true;
    root.buttonMode = true;
    root.on('pointerdown', this.focus.bind(this));

    this.updateLabel();
  }

  private updateLabel(value?: string) {
    if (!value && this.placeholder) {
      this.label.text = this.placeholder;
      this.label.alpha = 0.5;
      return;
    }

    this.label.alpha = 1;
    this.label.text = value || "";
  }

  private onInput() {
    this.updateLabel(this.value);
  }
  
  private onBlur() {
    this.updateLabel(this.value);
  }

  public focus() {
    this.label.text = this.value || "";
    doIOSFocusMagic(this.inputEl);
    // if (OS.iOS) {
    //   doIOSFocusMagic(this.inputEl);
    // } else {
    //   setTimeout(() => this.inputEl.focus(), 0);
    // }
  }

  public blur() {
    setTimeout(() => { this.inputEl.blur() }, 0);
  }

  public isValid() {
    return Boolean(this.value);
  }

  public set value(value: string) {
    this.updateLabel(value);
    this.inputEl.value = value;
  }

  public get value() {
    return this.inputEl.value;
  }
}

function createInputEl() {
  const inputEl = document.createElement("input");
  
  inputEl.style.position = "absolute";
  inputEl.style.top = "calc(50vh - 10px)";
  inputEl.style.left = "calc(50vw - 85px)";
  inputEl.style.opacity = "0";
  inputEl.style.pointerEvents = "none";
  inputEl.style.zIndex = "-1000";
  inputEl.autocomplete = "off";
  inputEl.spellcheck = false;

  document.body.appendChild(inputEl);

  return inputEl;
}

// Based on: https://stackoverflow.com/a/55652503
function doIOSFocusMagic(target: HTMLInputElement) {
  // create invisible dummy input to receive the focus first
  const fakeInput = createInputEl();
  // focus so that subsequent async focus will work
  fakeInput.focus();

  setTimeout(() => {
    // now we can focus on the target input
    target.focus();
    // cleanup
    fakeInput.remove(); 
  }, 1000);
}
